class CartDrawerUpsell extends HTMLElement {
  connectedCallback() {
    this.dialog = this.closest('dialog');
    if (!this.dialog) return;
    this.onDrawerOpen = () => {
      if (this.dialog.open) this.loadRecommendations();
    };
    this.dialog.addEventListener('toggle', this.onDrawerOpen);
    this.dialogObserver = new MutationObserver(this.onDrawerOpen);
    this.dialogObserver.observe(this.dialog, { attributes: true, attributeFilter: ['open'] });
    if (this.dialog.open) this.loadRecommendations();
  }

  disconnectedCallback() {
    this.dialog?.removeEventListener('toggle', this.onDrawerOpen);
    this.dialogObserver?.disconnect();
  }

  async loadRecommendations() {
    if (this.dataset.loaded === 'true' || this.dataset.loading === 'true') return;
    this.dataset.loading = 'true';
    try {
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!cartResponse.ok) throw new Error('Cart could not be read');
      const cart = await cartResponse.json();
      const inCart = new Set((cart.items || []).map((item) => String(item.product_id)));
      const url = new URL(this.dataset.recommendationUrl, window.location.origin);
      url.searchParams.set('product_id', this.dataset.productId);
      url.searchParams.set('limit', '10');
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('Recommendations could not be loaded');
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const candidates = Array.from(parsed.querySelectorAll('.ak-cart-upsell-candidate'))
        .filter((item) => !inCart.has(String(item.dataset.productId)));
      for (let index = candidates.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [candidates[index], candidates[swapIndex]] = [candidates[swapIndex], candidates[index]];
      }
      const chosen = candidates.slice(0, 2);
      this.dataset.loaded = 'true';
      if (!chosen.length) {
        this.hidden = true;
        return;
      }
      const heading = document.createElement('div');
      heading.className = 'ak-cart-upsell__heading';
      heading.innerHTML = '<p class="ak-cart-upsell__eyebrow">A considered pairing</p><h3>Complete the room</h3>';
      const list = document.createElement('div');
      list.className = 'ak-cart-upsell__list';
      chosen.forEach((candidate) => {
        const item = candidate.cloneNode(true);
        item.classList.remove('ak-cart-upsell-candidate');
        item.classList.add('ak-cart-upsell__item');
        item.removeAttribute('data-product-id');
        list.append(item);
      });
      this.replaceChildren(heading, list);
      this.hidden = false;
    } catch (_error) {
      this.dataset.loaded = 'true';
      this.hidden = true;
    } finally {
      delete this.dataset.loading;
    }
  }
}
if (!customElements.get('cart-drawer-upsell')) {
  customElements.define('cart-drawer-upsell', CartDrawerUpsell);
}
